/** TicketsTab — "Tickets" tab wrapper. Props: data */
import React from 'react';
import TicketList from './TicketList';

export default function TicketsTab({ data }) {
  return (
    <div className="sq__pane">
      <div className="sq__card">
        <div className="sq__card-title">All Tickets This Period</div>
        <TicketList tickets={data.allTickets} categories={data.categories} />
      </div>
    </div>
  );
}
